import React from 'react';
import { MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { getActiveStatus } from '../helpers';

const List = ({ items, withServicesId, doRequestFunc, queryString, queryRequest, withAll }) => (
  <>
    {items.map((elem, index) => (
      <MenuItem
        key={index}
        className={classNames(
          String(getActiveStatus(queryString, queryRequest, withAll)) === String(elem.id) && elem.active === false
            ? 'custom__active-dropdown--item not-active-service'
            : String(getActiveStatus(queryString, queryRequest, withAll)) === String(elem.id)
              ? 'custom__active-dropdown--item'
              : elem.active === false
                ? 'not-active-service'
                : '', {
            'position-relative custom__active-dropdown-badge': !!elem.badge,
          },
        )}
        eventKey={elem.id}
        active={String(getActiveStatus(queryString, queryRequest, withAll)) === String(elem.id)}
        onSelect={(key) => {
          doRequestFunc(key);
        }}
      >
        {withServicesId && elem.id !== null && <span className="item-id">{elem.id}</span>}
        {elem.title}
      </MenuItem>
    ))}
  </>
);

List.propTypes = {
  items: PropTypes.array,
  withServicesId: PropTypes.bool,
  doRequestFunc: PropTypes.func,
  queryString: PropTypes.object,
  queryRequest: PropTypes.string,
  withAll: PropTypes.bool,
};

export default List;
